import { render, staticRenderFns } from "./ClaimTemplates.vue?vue&type=template&id=69b13e50&scoped=true&"
import script from "./ClaimTemplates.vue?vue&type=script&lang=js&"
export * from "./ClaimTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b13e50",
  null
  
)

export default component.exports